import { Component, computed, OnInit, signal, ViewChild } from '@angular/core';

import { GeoUtils } from 'src/app/utils/geo-utils';
import { AppComponent } from 'src/app/app.component';
import { CustomForms } from '../../forms/custom-forms';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';

import { MapBounds, MapComponent, MapLatLng, MapPolygon } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { SsoService } from 'src/app/services/sso/sso.service';
import { TiposMaster, ZonesService } from 'src/app/services/zones/zones.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { AuditoriaService } from 'src/app/services/auditoria/auditoria.service';

import { ZonaModel } from 'src/app/services/zones/models/zona.model';
import { Accion } from 'src/app/services/auditoria/models/accion.model';
import { AuditoriaModel } from 'src/app/services/auditoria/models/auditoria.model';
import { AmbitoActividadModel } from 'src/app/services/geographics/ambito-actividad.model';
import { Utils } from 'src/app/utils/utils';
import { MenuComponent } from '../../main/menu/menu.component';
import { AmbitoActividadService } from 'src/app/services/geographics/ambitoActividad/ambito-actividad.service';
import { CuadriculaService } from 'src/app/services/cuadricula/cuadricula.service';

@Component({
  selector: 'app-ambito',
  templateUrl: './ambito.component.html',
  styleUrls: ['./ambito.component.css']
})
export class AmbitoComponent extends CustomForms implements OnInit {
  @ViewChild('form') form: jqxWindowComponent;
  @ViewChild('grid') grid: jqxGridComponent;

  public static _this: AmbitoComponent;

  private componentRef = null;
  public theme = environment.tema;
  private zonas: ZonaModel[] = [];
  public selectedAreas = [];
  public marcoAmbitoPolygon: MapPolygon;
  public visible = false;
  private map: MapComponent;
  public arrPolygonsGeojson = [];
  public arrCircles = [];
  public mapBounds;
  // Variables para guardar el ámbito de actividad
  public ambitoActividad: AmbitoActividadModel;
  // Variables para el grid
  public dataSource: any = [];
  public dataAdapter = new jqx.dataAdapter(this.dataSource);
  public columns = [
    { text: 'Id', columntype: 'textbox', filtertype: 'textbox', datafield: 'id', width: 50, hidden: true },
    { text: AppComponent.translate('Nombre'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 140, },
    { text: AppComponent.translate('Tipo'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'tipo', width: 60, },
    { text: 'select', datafield: 'select', width: 1, hidden: true }
  ];

  // Pongo por defecto los textos en los controles del grid en español
  public langGrid = JqWidgets.getLocalization('es');
  private usuario = this.ssoService.getTicket().Usuario.Email;
  private auditoria: AuditoriaModel = new AuditoriaModel(this.usuario, 0);
  visibleMarco: any;
  polygonsJsonMap: any[] = [];
  defaultSideDimension: number = 500;

  countPartialResults = signal<number>(0);
  titleWindow = this.translate('Ambito_actividad');

  titleWindowSignal = computed(() => `${this.titleWindow} (${this.countPartialResults()})`);
  showLoader: boolean = false;
  isHandlingSelection = false;

  constructor(
    private ssoService: SsoService,
    private zonesService: ZonesService,
    private configService: ConfigService,
    private auditoriaService: AuditoriaService,
    private ambitoActividadService: AmbitoActividadService,
    private cuadriculaService: CuadriculaService
  ) {
    super();
    AmbitoComponent._this = this;
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.getDefaultSideDimension();
  }

  async getDefaultSideDimension() {
    this.defaultSideDimension = await this.cuadriculaService.getConfigLado();
  }

  //recuperar datos del ambito de actividad
  async loadAmbito() {
    MainComponent.getInstance().hideAmbito(false);
    const res = await this.configService.getEmpApp('ambito-actividad', 'default');
    this.visible = await this.configService.getEmpApp('ver-ambito-actividad', 'false') === 'true';
    const ambito: AmbitoActividadModel = JSON.parse(res);
    this.ambitoActividad = ambito;
    if(!this.ambitoActividad.lado || this.ambitoActividad.lado === 0){
      this.ambitoActividad.lado = this.defaultSideDimension;
    }
    //filtrar filas que coinciden con los datos almacenados
    const result = this.grid.getrows().filter(e => {
      return ambito.zonas.indexOf(e.id) != -1;
    });
    //seleccionar filas
    result.forEach(row => {
      this.grid.selectedrowindex(row.uid)
      this.grid.setcellvalue(row.uid, 'select', true);
    })

    this.grid.sortby('select', 'asc');
    this.grid.sortby('nombre', 'asc');
    this.showLoader = false;
  }

  // Obtengo las zonas de la empresa
  async getZones() {
    this.zonas = await this.zonesService.getZonas();
    if (this.zonas) {
      this.dataSource = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'int', map: 'Id' },
          { name: 'nombre', type: 'string', map: 'Nombre' },
          { name: 'tipo', type: 'string', map: 'TipoNombre' },
          { name: 'select', type: 'bool', map: 'select' }
        ],
        localdata: this.zonas,
      }
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);
      //Utils.renderSizeGrid(this.grid, 500);
    } else {
      this.zonas = [];
    }
  }

  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    let filterColumns = [
      'nombre',
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  // Inicialización del componente
  init(componentRef: any) {
    this.componentRef = componentRef;
  }

  async ngAfterViewInit() {
    this.map = MainComponent.getActiveMap();
    this.addCustomForm(this.form);
    // Posiciono el formulario
    const mapContainer = document.getElementById('center-container').getClientRects();
    this.form.position({
      x: mapContainer[0].left + 2,
      y: mapContainer[0].top + 60
    });
    await this.getZones();
    this.loadAmbito();
  }

  //cuando se cierra la ventana
  public onClose() {
    if (this.arrCircles.length > 0 || this.arrPolygonsGeojson.length > 0 || this.polygonsJsonMap.length > 0) {
      this.deletePolygons();
    }
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    if (this.marcoAmbitoPolygon) {
      this.deleteMarcoAmbito();
    }
    MainComponent.getInstance().showAmbito();
    AmbitoComponent._this = null;
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  onSelect(event) {
    if (this.isHandlingSelection) {
      return;
    }

    this.isHandlingSelection = true;
    this.selectedAreas = [];
    const rowSel = this.grid.getselectedrowindexes();

    if (rowSel.length > 0) {
      rowSel.forEach(idx => {
        this.selectedAreas.push(this.zonas[idx]);
      });

      this.drawPolygons(this.selectedAreas);

      this.centeredPolygons(this.selectedAreas);

      this.map.fitTo(this.mapBounds);
      this.showMarcoAmbito();
    } else {

      this.deleteMarcoAmbito();
      this.deletePolygons();
    }

    this.isHandlingSelection = false;
  }


  //se activa cuando se hace check en Ver
  onChangeVisible(event) {
    this.visible = event.currentTarget.checked;
    if (this.selectedAreas.length > 0) {
      this.drawPolygons(this.selectedAreas);
      this.centeredPolygons(this.selectedAreas);
      //funcion que centra el mapa a un area
      this.map.fitTo(this.mapBounds);
      this.showMarcoAmbito();
    } else {
      this.deleteMarcoAmbito();
      this.deletePolygons();
    }
  }

  onChangeMarco(event) {
    this.visibleMarco = event.currentTarget.checked;
    if (this.visibleMarco) {
      MainComponent.getInstance().showMarcoGeografico(true);
    } else {
      MainComponent.getInstance().hideMarcoCartografico(true);
    }
  }

  drawPolygons(zones: ZonaModel[]): void {
    this.deletePolygons();

    zones.forEach(zone => {
      switch (zone.Tipo) {
        case TiposMaster.ZONAADMIN:
          this.drawAdminZone(zone);
          break;

        default:
          switch (zone.TipoGeo) {
            case 1:
              this.drawPolygonFromGeoJson(zone);
              break;

            case 0:
              this.drawCircle(zone);
              break;

            default:
              return;
          }
          break;
      }
    });
  }

  private drawAdminZone(zone: ZonaModel): void {
    if(!zone.Geometria) {
      return;
    }

    const polygonOptions = {
      geometry: zone.Geometria.geometry,
      type: 'Feature'
    };

    const styleOptions = this.getPolygonStyleOptions(zone);
    const polygonJson = this.map.addGeoJson(polygonOptions, styleOptions);
    this.polygonsJsonMap.push(polygonJson);
  }

  private drawPolygonFromGeoJson(zone: ZonaModel): void {
    const polygonGeoJson = this.map.addPolygonsFromGeoJson(zone.Geometria, false, this.getPolygonStyleOptions(zone))[0];
    this.arrPolygonsGeojson.push(polygonGeoJson);
  }

  private drawCircle(zone: ZonaModel): void {
    const circleOptions = {
      dataModel: zone,
      content: zone.Nombre,
      strokeColor: '#227481',
      strokeOpacity: 0.3,
      strokeWeight: 1,
      fillColor: '#F3FF00',
      fillOpacity: 0.1,
      position: new MapLatLng(zone.Lat, zone.Lng),
      radius: zone.Radio,
      draggable: false,
      editable: false
    };

    const circle = this.map.addCircle(circleOptions);
    this.arrCircles.push(circle);
  }

  private getPolygonStyleOptions(zone: ZonaModel): any {
    return {
      dataModel: zone,
      content: zone.Nombre,
      strokeColor: '#227481',
      strokeOpacity: 0.3,
      strokeWeight: 1,
      fillColor: '#F3FF00',
      fillOpacity: 0.3,
      zIndex: 100
    };
  }

  private deletePolygons(): void {
    this.arrPolygonsGeojson.forEach(polygon => this.map.removePolygon(polygon));
    this.arrPolygonsGeojson = [];

    this.arrCircles.forEach(circle => this.map.removeCircle(circle));
    this.arrCircles = [];

    this.polygonsJsonMap.forEach(polygon => this.map.removeGeoJson(polygon));
    this.polygonsJsonMap = [];
  }

  centeredPolygons(zonas: ZonaModel[]) {
    if (!zonas || zonas.length === 0) {
      this.mapBounds = null;
      return;
    }

    const arrLat: number[] = [];
    const arrLng: number[] = [];

    zonas.forEach(zona => {
      if (zona.Geometria) {
        const arrayCoordenadas = zona.Geometria.geometry.coordinates;
        arrayCoordenadas.forEach(polygon => {
          polygon[0].forEach(coord => {
            arrLat.push(coord[1]);
            arrLng.push(coord[0]);
          });
        });
      } else {
        const newPos1 = GeoUtils.getNewLatLng(new MapLatLng(zona.Lat, zona.Lng), -zona.Radio, -zona.Radio);
        const newPos2 = GeoUtils.getNewLatLng(new MapLatLng(zona.Lat, zona.Lng), zona.Radio, zona.Radio);

        arrLat.push(newPos1.lat, newPos2.lat);
        arrLng.push(newPos1.lng, newPos2.lng);
      }
    });

    const coordMax = new MapLatLng(Math.max(...arrLat), Math.max(...arrLng));
    const coordMin = new MapLatLng(Math.min(...arrLat), Math.min(...arrLng));
    this.mapBounds = new MapBounds(coordMin, coordMax);
  }

  onGridDataUpdate() {
    this.countPartialResults.set(this.grid.getrows().length);
  }

  setLadoAmbito(event) {
    this.ambitoActividad.lado = Number.parseInt(event);
  }

  async onGuardar(event) {
    let marco = MainComponent.getInstance().marcoGeografico.marco
    // compruebo que el ambito de actividad no se salga del marco geográfico
    if (this.mapBounds.swCorner.lat < marco.swCorner.lat || this.mapBounds.swCorner.lng < marco.swCorner.lng ||
      this.mapBounds.neCorner.lat > marco.neCorner.lat || this.mapBounds.neCorner.lng > marco.neCorner.lng) {
      return MainComponent.showWarning('ATENCION', 'Error_ambito', 2000);
    } else {
      await this.saveModel();
      this.deleteMarcoAmbito();
      this.deletePolygons();
      this.form.close();
      MenuComponent.getInstance().loadMenu();
      window.location.reload();
      this.auditoria.AccionId = Accion.CONFIGURACION_AMBITO_DE_ACTIVIDAD;
      this.auditoriaService.addAuditoria(this.auditoria);
    }
  }

  async saveModel() {
    const arrIds = [];
    if (this.selectedAreas.length > 0) {
      this.selectedAreas.forEach(area => {
        arrIds.push(area.Id);
      })
    } else {
      // Si no hay zonas no hay marco
      this.mapBounds = new MapBounds(new MapLatLng(0, 0), new MapLatLng(0, 0));
    }
    const ambito = new AmbitoActividadModel(this.mapBounds, arrIds);
    ambito.lado = this.ambitoActividad.lado;
    await this.configService.setEmpApp('ambito-actividad', JSON.stringify(ambito));
    await this.ambitoActividadService.setAmbitoActividad(ambito);
    await this.configService.setEmpApp('ver-ambito-actividad', this.visible.toString());
  }

  //dibujar polígono(rectangulo) que contiene el ambito de actividad
  public showMarcoAmbito() {
    if (this.marcoAmbitoPolygon) {
      this.map.removePolygon(this.marcoAmbitoPolygon);
      this.marcoAmbitoPolygon = null;
    }
    this.marcoAmbitoPolygon = this.map.addPolygon({
      strokeColor: '#2500fb',
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillColor: '#000000',
      fillOpacity: 0
    });
    this.map.addPolygonPoint(this.marcoAmbitoPolygon, {
      dataModel: this,
      content: this.translate('Ambito_actividad'),
      position: this.mapBounds['swCorner']
    });
    this.map.addPolygonPoint(this.marcoAmbitoPolygon, {
      dataModel: this,
      content: this.translate('Ambito_actividad'),
      position: new MapLatLng(this.mapBounds.neCorner.lat, this.mapBounds.swCorner.lng)
    });
    this.map.addPolygonPoint(this.marcoAmbitoPolygon, {
      dataModel: this,
      content: this.translate('Ambito_actividad'),
      position: this.mapBounds.neCorner
    });
    this.map.addPolygonPoint(this.marcoAmbitoPolygon, {
      dataModel: this,
      content: this.translate('Ambito_actividad'),
      position: new MapLatLng(this.mapBounds.swCorner.lat, this.mapBounds.neCorner.lng)
    });
  }

  public deleteMarcoAmbito() {
    if (this.marcoAmbitoPolygon) {
      this.map.removePolygon(this.marcoAmbitoPolygon);
      this.marcoAmbitoPolygon = null;
    }
  }
}
